import React from 'react';
import { Anchor } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function UniqueMechanism() {
  return <section className="bg-periwinkle py-24 px-6 md:px-12 text-cream" data-id="element-147">
      <div className="max-w-4xl mx-auto text-center" data-id="element-148">
        <FadeIn data-id="element-149">
          <div className="flex justify-center mb-8" data-id="element-150">
            <div className="bg-cream/20 p-4 rounded-full" data-id="element-151">
              <Anchor className="w-10 h-10 text-cream" data-id="element-152" />
            </div>
          </div>
          <h2 className="text-4xl md:text-5xl mb-10" data-id="element-153">
            El Método del Ancla Invisible
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-154">
          <p className="text-xl md:text-2xl leading-relaxed font-light mb-8" data-id="element-155">
            No se trata de dejarlo llorar ni de desaparecer. Se trata de{' '}
            <strong className="font-semibold" data-id="element-156">
              acompañarlo de forma estratégica
            </strong>{' '}
            para que aprenda a regularse y descansar mejor.
          </p>
          <div className="bg-brown/10 p-8 md:p-12 rounded-3xl backdrop-blur-sm border border-cream/20" data-id="element-157">
            <p className="text-lg md:text-xl leading-relaxed" data-id="element-158">
              Con el Método del Ancla Invisible, vos seguís presente en todo
              momento. Usamos una técnica de{' '}
              <strong data-id="element-159">"Presencia Gradual"</strong> donde, a través de pequeños
              ajustes en tu forma de estar, tu bebé siente tu cercanía y su
              cuerpo se relaja lo suficiente para soltar el sueño profundo por
              sí mismo. Es práctico, amoroso y podés empezar esta misma noche.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}